import { render, staticRenderFns } from "./HomeTRecentStudyItem.vue?vue&type=template&id=21615140&scoped=true&"
import script from "./HomeTRecentStudyItem.vue?vue&type=script&lang=ts&"
export * from "./HomeTRecentStudyItem.vue?vue&type=script&lang=ts&"
import style0 from "./HomeTRecentStudyItem.vue?vue&type=style&index=0&id=21615140&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21615140",
  null
  
)

export default component.exports